import { useTheme } from '@/hooks/use-theme';
import { Outlet, useLocation } from '@tanstack/react-router';
import { AppShell } from './AppShell';
import { AuthGate } from './AuthGate';

const PUBLIC_PATHS: ReadonlyArray<string> = ['/login', '/signup'];

/**
 * Componente raiz do router — escolhe entre layout público (login/signup
 * sem chrome) e layout autenticado (AuthGate + AppShell + Outlet).
 *
 * Usa `useLocation` ao invés de TanStack layout routes pra evitar prefix de
 * path forçado quando há `id` em `createRoute` sem `path`. Resultado: paths
 * declarados em `router.tsx` (`/leads`, `/templates/$id`, etc) ficam exatamente
 * como estão, sem se tornar `/authed/leads`.
 *
 * Tema: chama `useTheme()` no nível raiz pra aplicar tema 1× por sessão e
 * reagir a mudanças em qualquer rota. Anti-FOUC depende do inline script em
 * `index.html` que roda antes do React montar.
 */
export function RootShell() {
  useTheme();
  const location = useLocation();
  const isPublic = PUBLIC_PATHS.includes(location.pathname);

  if (isPublic) {
    return <Outlet />;
  }

  return (
    <AuthGate>
      <AppShell>
        <Outlet />
      </AppShell>
    </AuthGate>
  );
}
